export type Monitorable<T, I extends Object> = T & {
    '%%Monitorable%%': MonitorData<T, I>
}

interface MonitorData<T, I extends Object> {
    monitors: I[],
    base: T
}

export function Monitorable<T extends object, I extends Object>(obj : T, monitors = [] as I[]) {
    const monitored = (obj instanceof Function ?
        function (this : any) { 
            for (let monitor of monitors) if (monitor instanceof Function) monitor.apply(this, arguments);
            return obj.apply(this, arguments); 
        }
        : {}) as Monitorable<T, I>;
        
    Object.setPrototypeOf(monitored, obj);
    Object.defineProperty(monitored, '%%Monitorable%%', { value: { monitors: [], base: obj} });

    for (let m of monitors) Monitor(monitored, m);

    return monitored;
}

export function Monitor<T, I extends Object>(monitored : Monitorable<T, I>, monitor : I) {
    const data = monitored['%%Monitorable%%'];
    for (const prop in monitor) if (monitor.hasOwnProperty(prop) && prop in monitored && !monitored.hasOwnProperty(prop)) {
        const base = (monitored as any)[prop];
        if (!(base instanceof Function)) throw new Error("Monitorable: cannot monitor a non-method: " + prop);
        (monitored as any)[prop] = function () {
            for (const monitor of data.monitors) if (monitor.hasOwnProperty(prop)) {
                (monitor as any)[prop].apply(this, arguments);
            }
            base.apply(data.base, arguments);
        };
    }
    data.monitors.push(monitor);
}

export function Unmonitor<T extends I, I extends Object>(monitored : Monitorable<T, I>, monitor : I) {
    const data = monitored['%%Monitorable%%'];
    let i = data.monitors.indexOf(monitor);
    if (i !== -1) data.monitors.splice(i, 1);
}

export interface SynchronousSetMonitor<T> {
    add? : (value: T) => void
    clear? : () => void
    delete? : (value: T) => void
}


// WEBPACK FOOTER //
// ./lib/Monitorable.ts